import React from 'react';
import { Link } from "react-router-dom";
import MultiCrops from '../BoundingBox';
import './style.css';
import DeleteIcon from '../../assets/images/delete-disabled.svg'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import 'react-widgets/dist/css/react-widgets.css';
import Combobox from 'react-widgets/lib/Combobox';
import HelperServices from '../../services/CommonServices'
import { Constants, ToolTipMessages } from '../../data/Constants'
import shortid from 'shortid'
import Tooltip from '@material-ui/core/Tooltip';

class CreateTemplate extends React.Component {
    constructor(props) {
        super(props)
        const extractionKeys = Constants.extractionKeys;
        this.templateId = this.props.match.params.id;
        const staticKey = Constants.staticKey
        this.state = {
            coordinates: [],
            file: null,
            fileData: null,
            templateId: '',
            previousTemplateId: '',
            classNames: [staticKey, ...extractionKeys],
            className: '',
            zoom: 1,
            minimumScale: 0.4,
            imageUploadFlag: false,
            show: false,
            modalHeading: '',
            modalInfo: '',
            showLoader: false,
            errorMessage: "",
            imgWidth: 0,
            imgHeight: 0,
            boxHeightDifference: 0,
            boxWidthDifference: 0,
            templateIdAlreadyExist: null
        }
        this.child = React.createRef();
        this.childMulticrop = React.createRef();
        this.uploadHandleshow = false;
    }

    componentDidMount() {

        this.props.imageDataHandler(this.props.uploadedImage)

        if (this.props.uploadedImage) {
            let self = this;
            this.setState({
                file: URL.createObjectURL(this.props.uploadedImage),
                fileData: this.props.uploadedImage,
            }, () => this.fitToFrame(self))
        }

        if (this.templateId) {
            this.setState({
                mode: Constants.editMode,
                templateId: this.templateId,
                imageUploadFlag: true,
                previousTemplateId: this.templateId
            })
            HelperServices.getTemplateImages(this.templateId, Constants.fullImage)
                .then((data) => {
                    let self = this;
                    this.setState({
                        file: data
                    }, () => {
                        this.createFile(data)
                        this.fitToFrame(self)
                    })
                })
                .catch((error) => {
                    let errorMessage = ""
                    try {
                        errorMessage = error.data.message
                    } catch (error) {
                        errorMessage = Constants.generalErrorMessage
                    }
                    this.setState({
                        modalHeading: Constants.headerGetImageError,
                        modalInfo: errorMessage
                    })
                    this.handleShow()
                })

            HelperServices.getTemplateTaggingData(this.templateId)
                .then((data) => {
                    this.setState({
                        errorMessage: data["templateCreationError"]
                    })
                    var uniqid = require('uniqid');
                    const coordinates = []
                    if (data.taggingData !== null) {

                        data['taggingData'].forEach(element => {
                            coordinates.push(
                                {
                                    x: element['xCoordinate'],
                                    y: element['yCoordinate'],
                                    width: element['width'],
                                    height: element['height'],
                                    id: 'id',
                                    classLabel: element['className'],
                                    uniqueid: uniqid()
                                }
                            )
                        });
                    }
                    this.setState({
                        coordinates: coordinates,
                    })
                })
                .catch((error) => {
                    let errorMessage = ""
                    try {
                        errorMessage = error.data.message
                    } catch (error) {
                        errorMessage = Constants.generalErrorMessage
                    }
                    this.setState({
                        modalHeading: Constants.headerGetAnnotationError,
                        modalInfo: errorMessage
                    })
                    this.handleShow()
                })
        }

        document.addEventListener("keyup", (event) => {
            if (event.key === "Escape" && this.uploadHandleshow) {
                window.location.replace("/")
            }
        })

    }

    handleClose = () => {
        this.setState({ show: false });
        if (this.uploadHandleshow) {
            window.location.replace("/")
        }
    };

    handleShow = () => this.setState({ show: true });

    handleZoomIncrement = event => {
        this.setState({ zoom: this.state.zoom + Constants.changeInZoom });
    };

    handleZoomDecrement = event => {
        if (this.state.zoom >= this.state.minimumScale + Constants.minimumZoomThreshold) {
            this.setState({ zoom: this.state.zoom - Constants.changeInZoom });
        }
    };

    dropDownOptions = () => {
        const selectedClasslabels = []
        this.state.coordinates.forEach(element => {
            if (element.classLabel) {
                selectedClasslabels.push(element.classLabel)
            }
        });
        const remainClassLabels = this.state.classNames;
        var index = remainClassLabels.indexOf(Constants.staticKey);
        if (index > -1) {
            remainClassLabels.splice(index, 1);
        }
        return [Constants.staticKey, ...remainClassLabels.sort()]
    }

    removeBoundingBox = (index) => {
        this.state.coordinates.splice(index.index, 1);
        const coordinates = this.state.coordinates;
        this.setState({
            coordinates: coordinates
        })
    }

    boundingBoxSelect = (boundingBox, indexArgs) => {
        // let { coordinates } = this.state.coordinates
        // coordinates[indexArgs].classLabel = boundingBox
        // this.setState({ coordinates })
        this.state.coordinates.map((coordinate, index) => {
            if (index === indexArgs) {
                coordinate.classLabel = boundingBox;
                this.state.coordinates[index] = coordinate;
            }
        })
        this.setState({ coordinates: this.state.coordinates });
    }

    onZoomChange = zoom => {
        this.setState({ zoom })
    }

    handleTemplateId = event => {
        if (event.target.value === "") {
            this.setState({ templateId: "", templateIdAlreadyExist: null });
        }
        if (event.target.value.match(Constants.templateIdRegex)) {
            this.setState({ templateId: event.target.value, templateIdAlreadyExist: null });
        }
        else {
            return false
        }
    };

    deleteCoordinate = (coordinate, index, coordinates) => {
        this.setState({ coordinates })
    }

    templateIdValidation = () => {
        if (!this.state.templateId.match(Constants.templateIdRegex)) {
            this.setState({
                modalHeading: Constants.headerInvalidIdException,
                modalInfo: Constants.infoInvalidIdException
            })
            this.handleShow();
            return false
        }
        else {
            return true
        }
    }

    boxesKeyValidation = () => {
        let classes = this.state.coordinates.map((coordinate) => coordinate.classLabel);
        let dynamicClasses = []
        this.state.coordinates.forEach(coordinate => {
            if (coordinate.classLabel !== Constants.staticKey) {
                dynamicClasses.push(coordinate.classLabel)
            }
        })
        let uniqueClasses = [...new Set(dynamicClasses)]

        if (classes.includes(undefined) || classes.includes("")) {
            this.setState({
                showLoader: false,
                modalHeading: Constants.headerKeyExceptionBBX,
                modalInfo: Constants.infoKeyUnassignedBBX
            })
            this.handleShow();
            return false
        }

        if (uniqueClasses.length !== dynamicClasses.length) {
            this.setState({
                modalHeading: Constants.headerKeyExceptionBBX,
                modalInfo: Constants.infoKeyMultipleBBX
            })
            this.handleShow();
            return false
        }

        return true
    }

    checkIdentifier = (key) => {
        return key.classLabel === Constants.staticKey;
    }

    boundingBoxCountValidation = () => {
        let identifierlist = this.state.coordinates.filter(this.checkIdentifier);
        let notIdentifierlist = this.state.coordinates.filter((key) => { return key.classLabel !== Constants.staticKey && key.classLabel !== undefined });
        if (identifierlist.length >= Constants.identifierRequired && notIdentifierlist.length >= 1) {
            return true;
        }
        return false;
    }

    boundingBoxCountValidationWithModal = () => {
        let identifierlist = this.state.coordinates.filter(this.checkIdentifier);
        let notIdentifierlist = this.state.coordinates.filter((key) => { return key.classLabel !== Constants.staticKey && key.classLabel !== undefined });
        if (identifierlist.length >= Constants.identifierRequired && notIdentifierlist.length >= 1) {

            return true;
        }
        this.setState({
            modalHeading: Constants.headerKeyExceptionBBX,
            modalInfo: Constants.infoMinimumBBXValidation
        })
        this.handleShow();
        return false;
    }

    uploadAnnotation = () => {
        let data = {};
        data.templateId = this.state.previousTemplateId === "" ? this.state.templateId : this.state.previousTemplateId
        data.newTemplateId = this.state.templateId
        data.mode = this.state.mode
        data.taggingData = []
        this.state.coordinates.map(coordinate => {
            let coordinateData = {};
            coordinateData.className = coordinate.classLabel;
            coordinateData.xCoordinate = coordinate.x;
            coordinateData.yCoordinate = coordinate.y;
            coordinateData.height = coordinate.height;
            coordinateData.width = coordinate.width;
            data.taggingData.push(coordinateData);
        })
        this.state.showLoader = true;
        let urlPath = this.props.location.pathname.split("/")
        let lastPath = urlPath[urlPath.length - 1]
        HelperServices.sendDataToServer(data)
            .then((data) => {
                if (data.status === Constants.successHttpStatusCode) {
                    if (lastPath !== Constants.createTemplate) {
                        this.setState({
                            showLoader: false,
                            show: true,
                            modalHeading: Constants.headerTemplateUpdatedStatus,
                            modalInfo: <div><span>{Constants.infoTemplateUpdated}</span><br /><div className="right-side"><button onClick={() => { window.location.replace("/") }} className="btn btn-primary">OK</button></div></div>
                        })
                    } else {
                        this.setState({
                            showLoader: false,
                            show: true,
                            modalHeading: Constants.headerTemplateCreatedStatus,
                            modalInfo: <div><span>{Constants.infoTemplateCreated}</span><br /><div className="right-side"><button onClick={() => { window.location.replace("/") }} className="btn btn-primary">OK</button></div></div>

                        })
                    }
                    this.uploadHandleshow = true;
                } else {
                    if (lastPath !== Constants.createTemplate) {
                        this.setState({
                            showLoader: false,
                            show: true,
                            modalHeading: Constants.headerTemplateUpdatedStatus,
                            modalInfo: <div><span>{Constants.templateUpdatingErrorMessage}</span><br /><div className="right-side"><button onClick={() => { window.location.replace("/") }} className="btn btn-primary">OK</button></div></div>

                        })
                    } else {
                        this.setState({
                            showLoader: false,
                            show: true,
                            modalHeading: Constants.headerTemplateCreatedStatus,
                            modalInfo: <div><span>{Constants.templateCreatedErrorMessage}</span><br /><div className="right-side"><button onClick={() => { window.location.replace("/") }} className="btn btn-primary">OK</button></div></div>

                        })
                    }
                }
            })
            .catch((error) => {
                let errorMessage = ""
                try {
                    errorMessage = error.data.message
                } catch (error) {
                    errorMessage = Constants.generalErrorMessage
                }
                this.setState({
                    modalHeading: Constants.headerSendingTaggedData,
                    modalInfo: errorMessage
                })
                this.handleShow()
            })
    }

    uploadImageAndAnnotation = () => {
        if (this.state.templateId.length !== 0) {
            if (this.boxesKeyValidation() && this.boundingBoxCountValidationWithModal()) {
                if (this.state.fileData != null) {
                    this.setState({
                        showLoader: true,
                    })
                    let { fileData, templateId, mode } = this.state;
                    const data = new FormData();
                    data.append('image', fileData)
                    data.append('templateId', templateId)
                    data.append('mode', mode)
                    HelperServices.uploadImage(data)
                        .then(response => {
                            this.uploadAnnotation()
                            this.setState({
                                mode: Constants.editMode,
                                showLoader: false,
                                imageUploadFlag: true
                            })
                        })
                        .catch(error => {
                            let errorMessage = ""
                            try {
                                errorMessage = error.data.message
                            } catch (error) {
                                errorMessage = Constants.generalErrorMessage
                            }
                            this.setState({
                                showLoader: false,
                                modalHeading: Constants.headerImageUploadError,
                                modalInfo: errorMessage
                            })
                            this.handleShow();
                        })
                }
                else {
                    this.setState({
                        modalHeading: Constants.headerKeyImgNotSelected,
                        modalInfo: Constants.infoKeyImgNotSelected,
                    })
                    this.handleShow();
                }
            }
        }
        else {
            this.setState({
                modalHeading: Constants.headerKeyIdNa,
                modalInfo: Constants.infoKeyIdNa
            })
            this.handleShow();
        }
    }


    submitDataAfterTemplateIdValidation = () => {
        if (!this.state.imageUploadFlag) {
            this.uploadImageAndAnnotation()
        }
        else if (this.boxesKeyValidation() && this.boundingBoxCountValidationWithModal()) {
            this.uploadAnnotation()
        }
    }

    checkTemplateExistOrNot = (templateId) => {
        if (templateId.length) {
            HelperServices.getTemplates().then((data) => {
                if (data.length <= 0) {
                    data = []
                }

                const foundtemplateId = data.find(item => item.templateId === templateId)
                if (!foundtemplateId) {
                    this.setState({ templateIdAlreadyExist: false })
                } else {
                    this.setState({ templateIdAlreadyExist: true })
                    this.uniqueTemplateNameModal();
                }

            }).catch(error => {
                let errorMessage = ""
                try {
                    errorMessage = error.data.message
                } catch (error) {
                    errorMessage = Constants.generalErrorMessage
                }
                this.setState({
                    modalHeading: "Error in fetching template(s)",
                    modalInfo: errorMessage
                })
                this.handleShow()
            })
        }
        else {
            this.templateNameEmptyModal();
        }

    }

    checkTemplateExistOrNotForSubmit = (templateId) => {
        if (templateId.length) {
            HelperServices.getTemplates().then((data) => {
                if (data.length <= 0) {
                    data = []
                }
                const foundtemplateId = data.find(item => item.templateId === templateId)
                if (this.state.mode === "edit") {
                    const foundPreviousTemplateId = data.find(item => item.templateId === this.state.previousTemplateId)
                    if (foundPreviousTemplateId.status === "Processing") {
                        this.setState({
                            modalHeading: Constants.headerTemplateUnderProcessing,
                            modalInfo: Constants.infoTemplateUnderProcessing
                        })
                        this.handleShow()
                    } else {
                        if (!foundtemplateId) {
                            this.setState({ templateIdAlreadyExist: false })
                            this.submitDataAfterTemplateIdValidation()
                        } else {
                            this.setState({ templateIdAlreadyExist: true })
                            this.uniqueTemplateNameModal()
                        }
                    }
                }
                else {
                    if (!foundtemplateId) {
                        this.setState({ templateIdAlreadyExist: false })
                        this.submitDataAfterTemplateIdValidation()
                    } else {
                        this.setState({ templateIdAlreadyExist: true })
                        this.uniqueTemplateNameModal()
                    }
                }

            })
                .catch(error => {
                    let errorMessage = ""
                    try {
                        errorMessage = error.data.message
                    } catch (error) {
                        errorMessage = Constants.generalErrorMessage
                    }
                    this.setState({
                        modalHeading: "Error in fetching templates",
                        modalInfo: errorMessage
                    })
                    this.handleShow()
                })
        }
        else {
            this.templateNameEmptyModal();
        }
    }

    submitBtnClick = () => {
        if (this.state.templateIdAlreadyExist === null) {
            let { templateId } = this.state
            if (this.state.mode === "edit") {
                let { previousTemplateId } = this.state
                if (previousTemplateId !== templateId) {
                    this.checkTemplateExistOrNotForSubmit(templateId)
                }
                else {
                    this.submitDataAfterTemplateIdValidation()
                }
            }
            else {
                this.checkTemplateExistOrNotForSubmit(templateId)
            }
        }
        else if (this.state.templateIdAlreadyExist === false) {
            this.submitDataAfterTemplateIdValidation()
        }
        else {
            this.uniqueTemplateNameModal()
        }
    }

    uniqueTemplateNameModal = () => {
        this.setState({
            modalHeading: "Template name not unique",
            modalInfo: "please type a unique template name"
        })
        this.handleShow();
    }

    templateNameEmptyModal = () => {
        this.setState({
            modalHeading: Constants.headerKeyIdNa,
            modalInfo: Constants.infoKeyIdNa
        })
        this.handleShow();
    }

    reset = e => {
        var coordinates = [];
        this.setState({
            coordinates,
            boxHeightDifference: 0,
            boxWidthDifference: 0
        })
    }

    async createFile(src) {
        let response = await fetch(src);
        let data = await response.blob();
        let metadata = {
            type: 'image/jpeg'
        };
        let file = new File([data], Constants.imgFileName, metadata);
        this.setState({
            fileData: file
        })
        this.props.imageDataHandler(this.state.fileData)
    }

    fitToFrame = (self) => {
        var img = new Image();
        img.src = this.state.file
        img.onload = function () {
            const transformDivParent = self.transformDiv.parentNode.parentNode;
            let zoomX = transformDivParent.clientWidth / this.width;
            let zoomY = transformDivParent.clientHeight / this.height;
            let zoom = Math.min(zoomX, zoomY)

            self.setState({
                zoom: zoom - 0.01,
                imgWidth: this.width,
                imgHeight: this.height,
                minimumScale: zoom
            })
        }
    }


    changeCoordinate = (coordinate, index, coordinates) => {
        this.childMulticrop.current.updateTooltipPosition(coordinate);
        if (coordinate.x + coordinate.width > this.state.imgWidth || coordinate.y + coordinate.height > this.state.imgHeight || coordinate.x < 0 || coordinate.y < 0) {
            this.setState({ coordinates: this.state.coordinates })
            return
        }
        this.setState({
            coordinates,
        })
    }

    comboBoxOnClick = () => {
        var boxId = '';
        if (document.activeElement.id.startsWith("bounding-dropdown")) {
            const dropdown_id = document.activeElement.id.replace("_input", '')
            boxId = dropdown_id.replace("bounding-dropdown", "box")
            document.getElementById(boxId).style.backgroundColor = 'rgba(0,0,0,0.2)'
            document.getElementById(boxId).focus()
            document.getElementById(dropdown_id).focus()
        }
        const boxes = document.getElementsByClassName("boundingbox")
        Array.from(boxes).forEach(box => {
            if (box.id !== boxId) {
                document.getElementById(box.id).style.backgroundColor = 'rgba(0,0,0,0)'
            }
        });

    }

    addBounding = () => {
        let { boxWidthDifference, boxHeightDifference } = this.state
        let coordinate = {}
        let boxWidth = this.state.imgWidth / 7
        let boxHeight = this.state.imgHeight / 9
        coordinate.x = this.state.imgWidth / 2 - (boxWidth) / 2 + boxWidthDifference
        coordinate.y = this.state.imgHeight / 2 - (boxHeight) / 2 + boxHeightDifference
        coordinate.width = boxWidth
        coordinate.height = boxHeight
        coordinate.id = shortid.generate()
        boxHeightDifference += this.state.imgHeight / 30
        boxWidthDifference += this.state.imgWidth / 30
        if (coordinate.x + coordinate.width > this.state.imgWidth || coordinate.y + coordinate.height > this.state.imgHeight || coordinate.x < 0 || coordinate.y < 0) {
            this.setState({ boxHeightDifference: 0, boxWidthDifference: 0 })
            return
        }
        this.setState({
            coordinates: [...this.state.coordinates, coordinate],
            boxHeightDifference,
            boxWidthDifference
        })
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            document.getElementById("templateIdInputBox").blur()
            let { templateId } = this.state
            if (this.state.mode === "edit") {
                let { previousTemplateId } = this.state
                if (previousTemplateId !== templateId) {
                    this.checkTemplateExistOrNot(templateId)
                }
            }
            else {
                this.checkTemplateExistOrNot(templateId)
            }
        }
    }

    clickDashboardRoute = () => {
        this.props.imageDataHandler(null)
    }

    render() {
        return (
            <div>
                {this.state.showLoader ?
                    <div className="loader-overlay-div">
                        <div className="app-loader" />
                    </div>
                    : null}
                <div className="container-fluid" >
                    <div className="row">
                        <div className="col mb-2 ml-5 mt-5">
                            <span className="montserrat heading-h1" >Templates</span>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-auto ml-5" style={{ height: "70px" }}>
                            <span className="template-name-text nunito pr-5">Template Name</span>
                        </div>
                        <div className="col-4">
                            <input id="templateIdInputBox" type="text" maxLength={Constants.maxLengthTemplateId} value={this.state.templateId}
                                onChange={this.handleTemplateId} onKeyPress={this.handleKeyPress} className={`form-control form-control-overwrite template-name-text-box source-sans-pro ${this.state.templateIdAlreadyExist ? "exist" : ""}`} />
                            {this.state.templateIdAlreadyExist ? <label className="template-exist-text">{Constants.templateIdExistMessage}</label> : null}
                            {this.state.templateId.length ? null : <label className="template-exist-text">{Constants.emptyTemplateName}</label>}
                        </div>
                        <div className="col">
                        </div>
                    </div>
                    <div className="row mb-2 ml-5 mr-5 template-border">
                        <div className="col-6 mb-2 mt-3">
                            <div className={this.state.file ? "card bounding-box-area" : "card bounding-box-area disabled-div"}>
                                <div className="card-body px-2" height="100%" >
                                    <div style={{ display: "flex", height: "100%", flexDirection: "column" }}>
                                        <div style={{ flex: "none", color: "#5D5D5D" }}>
                                            <span className="nunito assign-bbx-heading" >  Assign Bounding Areas </span>
                                            <p className="source-sans-pro" style={{ fontSize: "16px" }}>
                                                {Constants.assignBoundingAreaHelpText}
                                                <b> Type or select the name of a key from the drop-down list,</b> once a bounding box is defined.
                                                <br />
                                                <br />
                                                <b>Identifier</b> is a marking or text unique to the document
                                                <br />
                                                <b>Key</b> is information to be extracted e.g first name.
                                                <br />
                                                <Button className="btn add-bounding-box-button row-padding btn button-global source-sans-pro" onClick={this.addBounding}
                                                >Add Bounding Box</Button>
                                                {this.state.coordinates.length ? <Button className="row-padding btn button-global clear-bounding-box-button source-sans-pro" onClick={this.reset}
                                                >Clear Bounding Areas</Button> : null}
                                            </p>
                                        </div>
                                        <div style={{ width: "100%", flexGrow: "1", overflow: "auto", position: "relative", minHeight: "150px" }}>
                                            <div style={{ position: "absolute", top: "0", left: "0", right: "0", bottom: "10" }}>
                                                {this.state.coordinates.map((coordinate, index) => (
                                                    <div key={coordinate.uniqueid}>
                                                        <div className="bounding-box-list-wrapper">
                                                            <b>{index + 1} </b>
                                                            <Combobox
                                                                // dropUp={(this.state.coordinates.length <= 5 || this.state.coordinates.length - 2 > index)
                                                                //     ? false : true}
                                                                data={this.dropDownOptions()}
                                                                onChange={(value) => this.boundingBoxSelect(value, index)}
                                                                key={index} className="bounding-dropdown"
                                                                value={coordinate.classLabel}
                                                                placeholder="Select an option"
                                                                id={'bounding-dropdown_' + (index)}
                                                                onClick={() => this.comboBoxOnClick(index)}
                                                            />
                                                            <Tooltip title={ToolTipMessages.deleteBBX}>
                                                                <img style={{ cursor: "pointer" }} src={DeleteIcon} alt="Delete" onClick={(event) => this.removeBoundingBox({ index })} name="removeBoundingBox" />
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid" style={{ maxHeight: "76px", overflowY: "scroll" }}>
                                {this.boundingBoxCountValidation() ? null :
                                    <div className="row" >
                                        <div className="col-auto info">
                                            <p className="m-2">
                                                You need to specify at least 4 <strong>Identifiers</strong> and 1 <strong>key</strong> for a valid template</p>
                                        </div>
                                    </div>
                                }

                                {this.state.mode === Constants.editMode ? this.state.errorMessage !== "" ?
                                    <div className="row" >

                                        <div className="col-auto error">
                                            <p className="m-2">  {this.state.errorMessage}</p>
                                        </div>
                                    </div>
                                    :
                                    null : null}
                            </div>

                        </div>
                        <div className="col-6  mb-2 mt-3">
                            <div className="icon-bar">
                                <Tooltip title={ToolTipMessages.zoomInButton}>
                                    <input type="image" className="icon-img" onClick={this.handleZoomIncrement} src={require('../../assets/images/zoom-in.svg')} alt="+" />
                                </Tooltip>
                                <Tooltip title={ToolTipMessages.zoomOutButton}>
                                    <input type="image" className="icon-img" onClick={this.handleZoomDecrement} src={require('../../assets/images/zoom-out.svg')} alt="-" />
                                </Tooltip>
                            </div>
                            <div className="image-div">
                                <div style={{
                                    width: parseInt((this.state.zoom * this.state.imgWidth).toFixed()) + "px",
                                    height: parseInt((this.state.zoom * this.state.imgHeight).toFixed()) + "px"
                                }}>
                                    <div ref={(div) => { this.transformDiv = div }} className="image-transform-div" id="transform-div" style={{ transform: 'scale(' + this.state.zoom + ')' }}>
                                        <MultiCrops
                                            src={this.state.file}
                                            coordinates={this.state.coordinates}
                                            zoom={this.state.zoom}
                                            onChange={this.changeCoordinate}
                                            onDelete={this.deleteCoordinate}
                                            onClick={this.selectedBoundingBox}
                                            ref={this.childMulticrop}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-4 ml-5 mr-5">
                        <div className="col-4 mt-3">
                            <Link className=" btn button-border-global mr-2 source-sans-pro" to="/" onClick={this.clickDashboardRoute}>Dashboard</Link>
                            {this.state.mode === "edit" ? null : <Link className=" btn button-border-global mr-2 source-sans-pro" to="/upload-image">Back</Link>}
                        </div>
                        <div className="col">

                        </div>
                        <div className="col-auto mt-2">
                            {/* {
                                this.boundingBoxCountValidation() === false ? null : this.state.templateId !== "" ? !this.state.templateIdAlreadyExist &&
                                    <button className={`source-sans-pro ${this.state.file ? "btn button-global" : "btn button-global disabled-div"}`} onClick={this.submitBtnClick}> {this.state.mode === Constants.editMode ? 'Update template' : 'Create template'}</button>
                                    : null
                            } */}
                            <button className={`source-sans-pro ${this.state.file ? "btn button-global" : "btn button-global disabled-div"}`} onClick={this.submitBtnClick}> {this.state.mode === Constants.editMode ? 'Update template' : 'Create template'}</button>
                        </div>
                    </div>
                    <Modal className="modal-style text-justify" show={this.state.show} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>{this.state.modalHeading}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="table-view">
                            {this.state.modalInfo}
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        )
    }
}


export default CreateTemplate;
